module.exports = __webpack_public_path__ + "assets/img/20-double-eleven_Z170078.54d24a03.png";